//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import {
  ContentLibraryContentGroup,
  ContentLibrarySortType,
  ContentLibrarySourcesGroups,
  IContentLibraryFiltersOptions,
  IContentLibraryItemParams,
  IContentLibrarySourcesOptions,
} from '@apis/content-library/contentLibraryApiModel';
import { MediaLibrarySubPages } from '@media-library/constants/mediaLibraryConstants';

const REQUEST_ITEM_LIMIT = 50;

export const EmptySources: IContentLibrarySourcesOptions = {
  accountMentionIds: [],
  brandFeedPost: undefined,
  brandStoryPost: undefined,
  collectionId: undefined,
  contentGroup: undefined,
  curalateUserIds: [],
  pinterestUserIds: [],
  sourcesGroups: [],
  trackedBusinessUserIds: [],
  trackedHashtags: [],
  trackedUserIds: [],
} as const;

export const InitialSourceGroups: Record<
  MediaLibrarySubPages,
  IContentLibrarySourcesOptions
> = {
  ALL_MEDIA: {
    contentGroup: ContentLibraryContentGroup.NOTHING,
    sourcesGroups: [ContentLibrarySourcesGroups.ALL_MEDIA],
  },
  TEAM_MEDIA: {
    contentGroup: ContentLibraryContentGroup.NOTHING,
    sourcesGroups: [ContentLibrarySourcesGroups.TEAM_MEDIA],
  },
  MY_MEDIA: {
    curalateUserIds: [],
    contentGroup: ContentLibraryContentGroup.NOTHING,
  },
} as const;

export const EmptyFilters: IContentLibraryFiltersOptions = {
  dateRange: undefined,
  distribution: undefined,
  hasLabels: undefined,
  hasProducts: undefined,
  igHashtags: undefined,
  igUsernames: undefined,
  isDistributed: undefined,
  labels: undefined,
  mediaItemTypes: undefined,
  orientation: undefined,
  rightsStatuses: undefined,
  searchText: undefined,
  semanticTags: undefined,
  spamFiltering: undefined,
} as const;

export const InitialMediaLibraryItemParams: IContentLibraryItemParams = {
  filters: EmptyFilters,
  hydrateWithDeetsItems: true,
  limit: REQUEST_ITEM_LIMIT,
  offset: 0,
  orderBy: ContentLibrarySortType.TIME,
} as const;
